import { computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators';
import { RouterLayoutData } from './root-routes';

export class RouteDataService {
  public defaultRouterLayoutData: RouterLayoutData = {
    hideHeader: true,
    hideFooter: true
  };
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private childRouteDataSignal = toSignal(
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map(() => this.route),
      map(route => {
        while (route.firstChild) route = route.firstChild;
        return route;
      }),
      filter(route => route.outlet === 'primary'),
      mergeMap(route => route.data)
    )
  );

  public routeLayoutData = computed(
    () => this.childRouteDataSignal() || this.defaultRouterLayoutData
  );

  routeChangeSignal = toSignal(
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => this.router.url)
    )
  );
}
